import { Chip, TextField } from '@material-ui/core';
import React, { useState } from 'react';

import { ModelSecondaryButton } from '~/src/dash/components/model-secondary-button';
import { IStore } from '~/src/dash/reducers/store';
import { IWithStylesProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { isValidEmail } from '~/src/dash/utils/email';
import { growGrid, growGridLeft, growGridRight } from '~/src/dash/utils/material-dashboard-react';

export interface IRecipientProps {
  onChange: (recipients: string[]) => void;
  value: string[];
}

function recipientError(recipient: string, recipients: string[]) {
  const v = recipient.trim();
  if (!isValidEmail(v)) {
    return 'Email is not valid.';
  }
  if (recipients.indexOf(v) > -1) {
    return 'Email already in the list.';
  }
  return '';
}

export const FormRecipientView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: any) => ({
      chipContainer: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
      },
      growGrid,
      growGridLeft,
      growGridRight,
    }),
  },
  function ({ value, onChange, classes }: IRecipientProps & IWithStylesProps) {
    const [showErr, setShowErr] = useState(false);
    const [recipient, setRecipient] = useState('');
    const addRecipient = () => {
      if (!recipientError(recipient, value)) {
        setShowErr(false);
        setRecipient('');
        onChange([...value, recipient]);
      } else {
        setShowErr(true);
      }
    };
    return (
      <div>
        <div className={classes.growGrid}>
          <div className={classes.growGridLeft}>
            <TextField
              label='Recipient(s)'
              name='recipient'
              helperText={showErr && recipientError(recipient, value)}
              fullWidth
              value={recipient}
              onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                setRecipient(target.value);
              }}
              onKeyUp={(ev: React.KeyboardEvent) => {
                if (ev.key === 'Enter') {
                  addRecipient();
                }
              }}
              error={showErr}
              InputLabelProps={{
                style: { color: '#000000' },
              }}
            />
          </div>
          <div className={classes.growGridRight}>
            <ModelSecondaryButton onClick={addRecipient}>Add Recipient</ModelSecondaryButton>
          </div>
        </div>
        <div className={classes.chipContainer}>
          {value.map((recipient: string) => {
            return (
              <Chip
                key={recipient}
                label={recipient}
                onDelete={() => {
                  const data = [...value];
                  data.splice(data.indexOf(recipient), 1);
                  onChange(data);
                }}
              />
            );
          })}
        </div>
      </div>
    );
  },
);
